import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';
import { compose } from 'recompose';
import { Icon, Divider, Card } from 'semantic-ui-react';
import CampaignForm from '../../components/campaign-form';

import hasJSONAPIClient from '../../hocs/has-jsonapi-client';


const STYLES = {
  active: {
    background: 'rgba(0,0,0,.05)',
  },
};

class CampaignDashboardSettings extends Component {

  constructor() {
    super();
    this.state = {
      name: null,
      budget: null,
      liveDate: null,
      endDate: null,
      hashtags: null,
      hasChanged: false,
      isSaving: false,
      savedOk: false,
      version: 1,
    };
  }

  componentDidMount() {
    const { campaign: { name, budget, liveDate, endDate, hashtags, currency } } = this.props;
    this.setState({
      name,
      budget,
      liveDate: moment(liveDate),
      endDate: moment(endDate),
      hashtags,
      currency,
    });
  }

  componentWillReceiveProps = nextProps => {
    const { campaign: { name, budget, liveDate, endDate, hashtags, currency, version } } = nextProps;
    this.setState({
      name,
      budget,
      liveDate: moment(liveDate),
      endDate: moment(endDate),
      hashtags,
      currency,
      version,
    });
  }

  onInputChange = (event, { name, value }) => {
    this.setState({
      [name]: value,
      hasChanged: true,
      savedOk: false,
    });
  }

  onLiveDateChange = date => {
    this.setState({
      liveDate: date,
      hasChanged: true,
      savedOk: false,
    });
  }

  onEndDateChange = date => {
    this.setState({
      endDate: date,
      hasChanged: true,
      savedOk: false,
    });
  }

  onCurrencyChange = (event, data) => {
    const { value } = data;
    this.setState({
      currency: value,
      hasChanged: true,
      savedOk: false,
    });
  }

  onFormSubmit = () => {
    const { jsonAPIClient, params } = this.props;
    const { name, budget, liveDate, endDate, currency, hashtags } = this.state;
    this.setState({
      isSaving: true,
    });
    jsonAPIClient.get('campaigns', params.id, {}, (err, campaign) => {
      campaign.set('name', name);
      campaign.set('budget', budget);
      campaign.set('hashtags', hashtags);
      campaign.set('currency', currency);

      if (liveDate && liveDate.isValid()) {
        campaign.set('liveDate', liveDate.format());
      }

      if (endDate && endDate.isValid()) {
        campaign.set('endDate', endDate.format());
      }

      campaign.sync()
        .then(this.setState({ isSaving: false, hasChanged: false, savedOk: true }, this.props.children.fetchCampaign));
    });
  }

  render() {
    const {
      name,
      budget,
      hashtags,
      liveDate,
      endDate,
      currency,
      hasChanged,
      savedOk,
    } = this.state;

    const campaignFormProps = {
      name,
      budget,
      hashtags,
      liveDate,
      endDate,
      currency,
      onInputChange: this.onInputChange,
      onLiveDateChange: this.onLiveDateChange,
      onEndDateChange: this.onEndDateChange,
      onCurrencyChange: this.onCurrencyChange,
    };

    const shouldDisableSubmitButton = savedOk || !hasChanged;

    return (
      <div>
        <Card.Group itemsPerRow={2}>
          <Card>
            <Card.Content style={STYLES.active}>
              <Card.Header>
                <Icon name="settings" />&nbsp;Campaign Settings
              </Card.Header>
            </Card.Content>
            <Card.Content>
              <CampaignForm {...campaignFormProps} />
              <Divider />
              <DyzioPrimaryButton
                fluid
                label="Save"
                hasIcon
                disabled={shouldDisableSubmitButton}
                onClick={this.onFormSubmit}
                icon={<Icon name="save" />}
              />
            </Card.Content>
          </Card>
        </Card.Group>
      </div>
    );
  }
}

CampaignDashboardSettings.propTypes = {
  campaign: PropTypes.object.isRequired,
  children: PropTypes.node.isRequired,
};

export default compose(
  hasJSONAPIClient,
)(CampaignDashboardSettings);



/** WEBPACK FOOTER **
 ** ./src/containers/campaign-dashboard-settings/index.js
 **/